<!-- Template: AuthorizationComponent (authorization.html)
     Purpose: PPN authorization (UAT / production) and login form (dev) on one page, using the
     same layout as the other Porsche portals: branding image left, form / status right. -->
<section class="login container">
  <div class="row">
    <!-- Left column: branding image (hidden on phones) -->
    <div class="col-md-6 d-none d-md-block">
      <div class="black-bg">
        <div class="img-box">
          <img src="/images/porsche-login.png" alt="Porsche" />
        </div>
      </div>
    </div>

    <!-- Right column: brand wordmark and (dev) the login form; errors are shown as toasts -->
    <div class="col-md-6">
      <div class="form-box">
        <!-- Brand wordmark -->
        <img
          src="/images/Porsche_wordmark_black_rgb.svg"
          alt="logo"
          class="header_logo"
          width="250"
        />

        @if (isDev) {
          <!-- Dev / local: login form bound to `loginForm`; submit handled via (ngSubmit) -->
          <form
            novalidate="novalidate"
            class="login-form"
            [formGroup]="loginForm"
            (ngSubmit)="onSubmit()"
          >
            <div class="row">
              <!-- Email field with validation messaging -->
              <div class="col-12">
                <p-input-email
                  name="userName"
                  [required]="true"
                  label="{{ 'Login ID (email address)' }}"
                  [message]="
                    isSubmitted && userForm.userName.hasError('email')
                      ? 'Please enter a valid email.'
                      : isSubmitted && userForm.userName.hasError('required')
                        ? 'Please enter your email address'
                        : ''
                  "
                  [state]="isSubmitted && userForm.userName.invalid ? 'error' : 'none'"
                  class="hydrated"
                  formControlName="userName"
                  (blur)="trim('userName')"
                ></p-input-email>
              </div>

              <!-- Password field with validation messaging -->
              <div class="col-12 mt-2">
                <p-input-password
                  name="password"
                  [required]="true"
                  label="{{ 'Password' }}"
                  [message]="
                    isSubmitted && userForm.password.hasError('required')
                      ? 'Please enter your password.'
                      : ''
                  "
                  [state]="isSubmitted && userForm.password.invalid ? 'error' : 'none'"
                  class="hydrated"
                  formControlName="password"
                  (blur)="trim('password')"
                ></p-input-password>
              </div>

              <!-- Submit button shows loading state when authenticating -->
              <div class="col-12 mt-2">
                <p-button
                  type="submit"
                  class="submit-btn"
                  variant="primary"
                  [loading]="isLoading()"
                  >{{ 'Login' }}</p-button
                >
              </div>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</section>
